// Türkiye bankaları — kurumsal renkli rozet (telifsiz: yalnızca ad + marka rengi).
export const BANKS = [
  { code: "ziraat", name: "Ziraat Bankası", color: "#e30613", bg: "#fdecec" },
  { code: "isbank", name: "Türkiye İş Bankası", color: "#0a3d91", bg: "#e7edf7" },
  { code: "garanti", name: "Garanti BBVA", color: "#00a94f", bg: "#e6f6ee" },
  { code: "akbank", name: "Akbank", color: "#e2001a", bg: "#fdeaec" },
  { code: "yapikredi", name: "Yapı Kredi", color: "#004a99", bg: "#e6eef7" },
  { code: "halkbank", name: "Halkbank", color: "#00539f", bg: "#e6eff7" },
  { code: "vakifbank", name: "VakıfBank", color: "#d9a400", bg: "#fff6df" },
  { code: "qnb", name: "QNB", color: "#5b2d8e", bg: "#efe8f5" },
  { code: "denizbank", name: "DenizBank", color: "#0096d6", bg: "#e2f4fb" },
  { code: "teb", name: "TEB", color: "#00693c", bg: "#e4f0ea" },
  { code: "enpara", name: "Enpara.com", color: "#7b2b8f", bg: "#f1e7f4" },
  { code: "ing", name: "ING", color: "#ff6200", bg: "#ffeede" },
  { code: "hsbc", name: "HSBC", color: "#db0011", bg: "#fce8ea" },
  { code: "kuveytturk", name: "Kuveyt Türk", color: "#00954c", bg: "#e5f4ec" },
  { code: "albaraka", name: "Albaraka Türk", color: "#e94e1b", bg: "#fdeee7" },
  { code: "sekerbank", name: "Şekerbank", color: "#e2001a", bg: "#fdeaec" },
  { code: "fibabanka", name: "Fibabanka", color: "#e2001a", bg: "#fdeaec" },
  { code: "diger", name: "Diğer", color: "#64748b", bg: "#f1f5f9" },
];

export const bankByCode = (code) => BANKS.find((b) => b.code === code) || null;

export function BankBadge({ code, className = "" }) {
  const b = bankByCode(code);
  if (!b) return null;
  return (
    <span
      data-testid={`bank-badge-${code}`}
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold ${className}`}
      style={{ color: b.color, backgroundColor: b.bg }}
    >
      <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: b.color }} />
      {b.name}
    </span>
  );
}
